import React from 'react';
import {observer} from 'mobx-react';
import {ITab, SimpleTabs} from '@techsee/techsee-ui-common/lib/tabs/simple';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {AgentGuidance} from '../components/agent-guidance/AgentGuidance';
import {InviteStepsLayout} from './_Shared';
import {InviteStepProps} from './_InviteGenericStep';
import {InviteDeviceType} from '../../_contracts/InviteContracts';

@observer
export class StepWifiTabs extends TechseeBaseComponent<InviteStepProps> {
    componentDidMount() {
        this.props.ctrl.setPagePlacement('sms-wifi-step');
    }

    renderInternal() {
        const {translate} = this.props.ctrl;

        const tabsList: ITab[] = [];

        tabsList.push({title: 'Android', content: wifiTabs(InviteDeviceType.android)});
        tabsList.push({title: 'iOS', content: wifiTabs(InviteDeviceType.ios)});

        return (
            <InviteStepsLayout
                className={'wifi-step'}
                h1Text={translate('REACT.WIFI.TURN_OFF_WIFI')}
                h2Text={translate('REACT.WIFI.NETWORK_CONNECTION_NOTIFY')}>
                <SimpleTabs
                    key={this.props.ctrl.getSelectedDeviceTabIndex}
                    tabsList={tabsList}
                    uid={'wifi-step-tabs'}
                    initialTabIndex={this.props.ctrl.getSelectedDeviceTabIndex}
                    onChange={this.props.ctrl.onDeviceTabChange}
                />
            </InviteStepsLayout>
        );

        function wifiTabs(device: InviteDeviceType) {
            return () => (
                <React.Fragment>
                    <AgentGuidance
                        stepType={'wifi'}
                        stepNum={1}
                        deviceType={device}
                        stepText={translate('REACT.WIFI.LAUNCH_SETTINGS')}
                        tooltipPosition={{
                            top: device === InviteDeviceType.android ? '30%' : '49%',
                            left: '0%'
                        }}
                        maxHeight={'53px'}
                    />
                    <AgentGuidance
                        stepType={'wifi'}
                        stepNum={2}
                        deviceType={device}
                        stepText={translate(
                            device === InviteDeviceType.android
                                ? 'REACT.WIFI.SELECT_CONNECTIONS_OPTION'
                                : 'REACT.WIFI.SELECT_OPTION'
                        )}
                        tooltipPosition={{
                            top: device === InviteDeviceType.android ? '65%' : '78%',
                            left: device === InviteDeviceType.android ? '14%' : '12%'
                        }}
                    />
                    <AgentGuidance
                        stepType={'wifi'}
                        stepNum={3}
                        deviceType={device}
                        stepText={translate('REACT.WIFI.ON_OFF_SWITCH')}
                        tooltipPosition={{
                            top: device === InviteDeviceType.android ? '30%' : '49%',
                            left: '1%'
                        }}
                        maxHeight={'53px'}
                    />
                </React.Fragment>
            );
        }
    }
}
